export const DEFAULT_BASE_CURRENCY = 'USD';
export const DEFAULT_TIMEZONE = 'Asia/Beirut';
//# sourceMappingURL=family.js.map